import {
  TABLE_DEFAULT_COLUMN_WIDTH,
  TABLE_DEFAULT_NAME_COLUMN_WIDTH,
} from './constants';
import {type ConfigV2} from './runfeed';
import * as Run from './runs';
import {type Key} from './runTypes';

export function defaultColumnWidth(k: Key) {
  if (k.section === 'run' && k.name === 'displayName') {
    return TABLE_DEFAULT_NAME_COLUMN_WIDTH;
  }
  return TABLE_DEFAULT_COLUMN_WIDTH;
}

export function getColumnWidth(tableSettings: ConfigV2, key: Key) {
  const columnKeyString = Run.keyToString(key);
  return Math.floor(
    (tableSettings.columnWidths &&
      tableSettings.columnWidths[columnKeyString]) ??
      defaultColumnWidth(key)
  );
}
